import {BigInput} from "../../forms/bigInput/BigInput";
import TextAreaNext from "../../forms/textAreaNext/TextAreaNext";
import Checkbox from "../../forms/checkbox/Checkbox";
import Sunglasses from "../../../assets/images/sunglasses.png";
import TimePicker from "../../forms/timePicker/TimePicker";
import {SHIPMENT_FLOW_TRIGGER_IDS} from "../../../consts/SHIPMENT_FLOW_TRIGGER_IDS";

interface Step2FieldsProps {
    triggerDelay: number | null;
    setTriggerDelay: (newVal: number | null) => void;
    flowTriggerId?: number;
}

const Step2Fields = ({ triggerDelay, setTriggerDelay, flowTriggerId }: Step2FieldsProps) => {
    const immediateFlowTriggerIds = SHIPMENT_FLOW_TRIGGER_IDS;
    return (
        <>
            <TimePicker title='Message Timer' value={triggerDelay} setValue={setTriggerDelay} includeImmediateValue={!!flowTriggerId && immediateFlowTriggerIds.includes(flowTriggerId)} description='How long would you like to wait for the user to complete the purchase by his own, before sending him this message? (It can range between 15 minutes to 2 months)' />
        </>
    )
}

export default Step2Fields;